import React from 'react'
import { FunctionComponent, ReactNode } from 'react'
import E3DShareIcon from '../../assets/media/icons/e3d-share.svg'
import useTranslation from '../../hooks/useTranslation'
import style from './cartboxE3DButton.css'

export type Props = {
    isLoggedIn: boolean
    isLoading: boolean
    openE3DModal: () => void
    isDisabled?: boolean
    tooltipText?: string
    brand: string
}

const CartboxE3DButton: FunctionComponent<Props> = ({ openE3DModal, isDisabled, tooltipText, brand }) => {
    const { t } = useTranslation()

    const createIconElement = (): ReactNode => {
        return <E3DShareIcon className={style.icon} />
    }

    const createLabelElement = (label: string): ReactNode => {
        return <div className={style.label}>{label}</div>
    }

    const content = (
        <>
            {createIconElement()}
            {createLabelElement(t(`e3d.${brand}.shareThisVehicle`))}
        </>
    )

    return (
        <button
            className={style.button}
            onClick={openE3DModal}
            data-testid="cartbox-e3d-share-button"
            disabled={isDisabled}
            title={tooltipText}>
            {content}
        </button>
    )
}

export default CartboxE3DButton
